module.exports = __webpack_public_path__ + "img/企业统计 区划.c0ae829e.png";